import { NgModule } from '@angular/core';
import { ParkedCarsComponent } from './parked-cars.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  declarations: [ParkedCarsComponent],
  imports: [SharedModule, AppRoutingModule, MatPaginatorModule],
  exports: [ParkedCarsComponent],
})
export class ParkedCarsModule {}
